export { wrapRootElement } from "./src/apollo/wrap-root-element"
// https://github.com/gatsbyjs/gatsby/issues/9087
// exports.onServiceWorkerUpdateReady= () => window.location.reload(true);

if (typeof window !== "undefined") {
  window.__defined = function($context, $variable, $callback) {
    if ($context[$variable]) {
      $callback()
    } else {
      Object.defineProperty($context, $variable, {
        configurable: true,
        enumerable: true,
        writeable: true,
        get: function() {
          return this["_" + $variable]
        },
        set: function(val) {
          this["_" + $variable] = val
          $callback()
        },
      })
    }
  }
}
